import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { colors } from 'src/theme';

// ============ INTERFACE ============

export interface MessageStateInterface {
  visible: boolean;
  message: string;
  duration: number;
  backgroundColor?: string;
}

interface MessageActionInterface {
  type: string;
  message: string;
  duration: number;
}

// ============ INIT STATE ============

const initialState: MessageStateInterface = {
  visible: false,
  message: '',
  duration: 10000
};

// ============ SLICE ============

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<MessageActionInterface>) => {
      state.visible = true;
      state.message = action.payload.message;
      state.duration = action.payload.duration;

      switch (action.payload.type) {
        case 'success':
          state.backgroundColor = colors.success2;
          break;
        case 'error':
          state.backgroundColor = colors.error2;
          break;
        case 'info':
          state.backgroundColor = colors.info2;
          break;
        default:
          state.backgroundColor = colors.success2;
      }
    },
    hideMessage: (state) => {
      state.visible = false;
    }
  }
});

export const { showMessage, hideMessage } = messageSlice.actions;

export default messageSlice.reducer;
